import { createContext, useContext } from 'react';

interface EscalationState {
  effectiveLevel: string;
  ceiling: string;
}

const EscalationContext = createContext<EscalationState>({
  effectiveLevel: 'l1',
  ceiling: 'none',
});

export const EscalationProvider = EscalationContext.Provider;

export function useEscalationLevel(): EscalationState {
  return useContext(EscalationContext);
}
